import React from "react";
import { Text } from "basis";

import Link from "../../Link";
import { FEES, RATES } from "./constants";
import { calculateTotals } from "./utils";

export const Flexible = ({
  onLearnMoreClick = () => {},
  promotion,
  amount,
  currency,
  learnMoreURL,
  au,
  nz,
}) => {
  const { promotionMonths } = promotion;

  const { monthlyFees, monthlyPrice, totalPrice } = calculateTotals(
    amount,
    currency,
    promotionMonths
  );

  const AU = () => (
    <>
 
            <Text textStyle="body2" margin="0 0 3">
        <strong>
   
       Make payments at any time it suits you during the plan period.
        </strong>{" "}
        </Text>
              <Text textStyle="body2" margin="0 0 3">

       Interest will charged at the Expired Plan Rate of {RATES.GEM_VISA_AU}% p.a. (subject to change) on any outstanding balance at the end of your plan period. Monthly credit card fee of ${monthlyFees} per month applies (subject to change).
       </Text>
        <Link
          href={learnMoreURL}
          onClick={onLearnMoreClick}
          newTab
          smallFont
          inline
        >
          Learn more
        </Link>
 
{/* 
      <Text textStyle="body2" margin="3 0">
        You need to pay the purchase amount in equal monthly instalments over
        the plan period.
      </Text> */}
    </>
  );

  const NZ = () => (
    <>
     <Text textStyle="body2" margin="0 0 3">
           <strong>
             Make payments at any time it suits you during the plan period.
           </strong>
         </Text>
     
         <Text textStyle="body2" margin="0 0 3">
             Interest applies on any outstanding balance at the end of your plan period. Standard interest rate (currently ${RATES.GEM_VISA_NZ} p.a.(subject to change)) applies after interest free term ends.
         </Text>
     
         <Link href={learnMoreURL} onClick={onLearnMoreClick} newTab smallFont>
           Learn more
         </Link>
    </>
  );

  return (
    <>
      {au && <AU />}
      {nz && <NZ />}
    </>
  );
};
